module.exports = __webpack_public_path__ + "static/img/品牌核心.0e0f57ac.png";